import { render } from "./[alias].vue?vue&type=template&id=1d6f35bc&scoped=true"
import script from "./[alias].vue?vue&type=script&lang=js"
export * from "./[alias].vue?vue&type=script&lang=js"

import "./[alias].vue?vue&type=style&index=0&id=1d6f35bc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6f35bc"]])

export default __exports__